var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:({
    callback: _vm.visibilityChanged,
    once: true,
  }),expression:"{\n    callback: visibilityChanged,\n    once: true,\n  }"}]},[(_vm.banners && _vm.banners.length > 0)?_c('section',{staticClass:"home--promo-container"},[_c('div',{staticClass:"slider"},[_c('slick-banner',{attrs:{"banners":_vm.banners}})],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }